import React, { Fragment } from "react";
import ReactHtmlParser from "react-html-parser";
var md = require("markdown-it")({
  html: true,
  linkify: true,
  typographer: true,
});
var mila = require("markdown-it-link-attributes");
md.use(mila, [{
  matcher(href, config) {
    return href.startsWith("https://chatapps");
  },
  attrs: {   
    rel: "noopener",
    class: "internal-link"
  },
},
{
  matcher(href, config) {
    return !href.startsWith("https://chatapps");
  },
  attrs: {
    target: "_blank",
    rel: "noopener",
    class: "external-link"
  },
}]);

// var defaultRender =
//   md.renderer.rules.link_open ||
//   function (tokens, idx, options, env, self) {
//     return self.renderToken(tokens, idx, options);
//   };

// md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
//   //console.log("customer message")
//   console.log(tokens)
//   //console.log(tokens[idx].attrGet('href'));
//   const url=tokens[idx].attrGet('href');
//   console.log(url)
//   if (
//     url.toLowerCase().includes("chatapps") &&
//     url.toLowerCase().includes("bookmebob.com")
//   ) {
//     console.log("in")
//     tokens[idx].attrPush(["onclick", "openChatapps();"]);
//   }
//   else{
// // If you are sure other plugins can't add `target` - drop check below
// var aIndex = tokens[idx].attrIndex("target");
// if (aIndex < 0) {
//   tokens[idx].attrPush(["target", "_blank"]); // add new attribute
// } else {
//   tokens[idx].attrs[aIndex][1] = "_blank"; // replace value of existing attr
// }
//   }
  
//   // pass token to default renderer.
//   return defaultRender(tokens, idx, options, env, self);
// };
export default function CustomMessage({
  content,
  messageId,
  conversationId,
  iid,
  replyToId,
  cardActivitiesSummary,
  inZenDesk,
}) {
  let feedback_response = JSON.parse(
    localStorage.getItem(iid + "-chatfeedback")
  );
  let feedbackbody;
  if (feedback_response !== null) {
    feedbackbody = feedback_response.filter(
      (i) => i.messageId === messageId
    )[0];
  }
  return (
    <div
      className="markdown"
      data-activity-id={messageId}
      text-len={content.length}
      data-con-id={conversationId}
      width={content.length > 50 ? "true" : "false"}
      data-feedback={feedbackbody !== undefined && feedbackbody.feedback}
      data-view-btn={replyToId}
      data-msg-type={cardActivitiesSummary}
      data-inzendesk={inZenDesk}
    >
      {content !== undefined &&
        content !== null &&
        content
          .split("\n")
          .map(
            (item, key) =>
              item !== "" && (
                <Fragment key={key}>
                  {ReactHtmlParser(md.render(item))}
                </Fragment>
              )
          )}
    </div>
  );
}
